<template>
  <div>
    <breadcrumb/>
    <product-list url="/products" :style="getZoomByScreen()"/>
  </div>
</template>

<script>
import ProductList from "@/components/Products/ProductList";
import Breadcrumb from "@/components/General/Breadcrumb";

export default {
  components: {
    ProductList,
    Breadcrumb
  },
  methods: {
    getZoomByScreen() {
      if (window.innerWidth <= 1366 && window.innerWidth >= 960)
        return "margin-bottom: -200px;";
    }
  },
  mounted(){
    // Manda el scroll al inicio cada vez que se cambia de ruta
    window.scrollTo(0, 0);
  },
};
</script>

